import React, { useState, useEffect, useContext, useRef } from "react";
import { Form, Table, Input, Select, Checkbox, InputNumber, Button } from "antd";
import { DatePicker } from "../../lib/date";
import {getProcessParamComboFillField} from "../../services/generic";
import dayjs from "dayjs";
import { useParams } from "react-router";
import { Resizable } from "react-resizable";

const ResizableCell = (props) => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};


const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
const EditableContext = React.createContext(null);
const { Option } = Select;

const RecordTable = (props) => {
  const { dataSource, columns, selectedRecordsData, setSelectedRecordsData,handleSave,propTableName,addLineFlag } = props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const uomFields = JSON.parse(localStorage.getItem("globalParameters")).UOM;
  const [checkboxSelections, setCheckboxSelections] = useState({}); // Track checkbox selections by column
  const { recordId } = useParams();
  const onSelectRowChange = (selectedRowKeys) => {
    setSelectedRowKeys([...selectedRowKeys]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectRowChange,
  };

  useEffect(() => {
    if (dataSource?.length > 0) {
      const selRecords = { ...selectedRecordsData };
      selRecords[dataSource[0].tableName] = [...selectedRowKeys];
      setSelectedRecordsData({ ...selRecords });
    }
  }, [selectedRowKeys]);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };
  
  const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, colData, rowIndex,allCols,...restProps }) => {
    // console.log(colData,allCols )
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    const toggleEdit = () => {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex] ? record[dataIndex] : "",
      });
      if (selectedRowKeys.findIndex((op) => `${rowIndex}` === `${op}`) < 0) {
        setSelectedRowKeys([...selectedRowKeys, `${rowIndex}`]);
      }
    };

    const save = async () => {
      try {
        const values = await form.validateFields(); 
        if (colData?.uom_field_id) {
          const fieldId = colData?.uom_field_id;
          const relatedCol = allCols[0].fields.find((col) => col.field_id === fieldId);
          if (relatedCol) {
            const relatedValue = record[relatedCol.field_name];
            if (relatedValue) {
              const uomField = uomFields?.find((item) => Object.keys(item)[0] === relatedValue);
              if (uomField) {
                const uomDetails = uomField[relatedValue];
                const standardPrecision = uomDetails?.standardPrecision;
                const inputValue = parseFloat(values[dataIndex]);
                if (!isNaN(inputValue)) {
                  let finalValue = inputValue;
                  // Apply rounding only if standardPrecision is specified and is a valid number
                  if (standardPrecision !== undefined ) {
                    finalValue = parseFloat(inputValue.toFixed(standardPrecision));
                  }
                  // Update the form, values, and record with the final value (rounded or not)
                  form.setFieldsValue({ [dataIndex]: finalValue });
                  values[dataIndex] = finalValue;
                  record[dataIndex] = finalValue;
                }
              }
            }
          }
        }
        const updatedRecord = { ...record, ...values };
        handleSave(updatedRecord,propTableName);
        toggleEdit();
      } catch (errInfo) {
        console.error("Save failed:", errInfo);
      }
    };
    
    
        

    let childNode = children;
    let actualValue = 0;
    if (dataIndex) {
      actualValue = record[dataIndex] !== null && record[dataIndex] !== undefined ? `${record[dataIndex]}`: "";
    }

    const getTimePeriod = () => {
      const dateValue = actualValue;
      const valueDate = dateValue ? dayjs(dateValue) : null;
      return valueDate;
    };

    const [optionMenu, setOptionMenu] = useState(colData ? [ { recordid: record[colData?.field_name], name: record[`${colData?.field_name}_iden`] } ]: []);
    const getOptionsMenuData = (value) => {
      const stringifiedSession = JSON.stringify(record);
      const updatedSession = stringifiedSession.replace(/\\"/g, '\\"');
        const stringRequest = JSON.stringify(updatedSession);
        getProcessParamComboFillField(colData.nt_process_id,colData.field_id,recordId,stringRequest,value).then((res) => {
          setOptionMenu(res.data.data.processParamComboFill?[...JSON.parse(res.data.data.processParamComboFill)]:[...optionMenu]);
        });
      // }
    };

    const saveOption = (_,opt) => {
      record[colData.field_name] = opt.value;
      record[`${colData.field_name}_iden`] = opt.children;

      setOptionMenu([{
        recordid: opt.value,
        name: opt.children
      }]);
      save();
    }

    const getField = () => {
      switch (colData.type) {
        case "Date":
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={getTimePeriod()}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y"  ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <DatePicker ref={inputRef} onBlur={save} format="DD-MM-YYYY" />
            </Form.Item>
          );
        case "Flag":
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={actualValue === "Y" || actualValue === "true"  ? true : false}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y" ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <Checkbox
                checked={actualValue === "Y" || actualValue === "true" ? true : false}
                onChange={(e) => {
                  const newValue = e.target.checked ? "Y" : "N";
                  form.setFieldsValue({ [dataIndex]: newValue });
                  if (selectedRowKeys.findIndex((op) => `${record.key}` === `${op}`) < 0) {
                    setSelectedRowKeys([...selectedRowKeys, `${record.key}`]);
                  }
                  handleSave({ ...record, [dataIndex]: newValue },propTableName);
                  // record[dataIndex] = newValue;
                }}
              />
            </Form.Item>
          );
        case "Number":
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={actualValue}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y" ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <InputNumber
              ref={inputRef}
              style={{ width: "100%" }}
              controls={true}            // show increment/decrement arrows
              min={0}                    // prevents arrow from going below 0
              parser={(value) => value}  // allow manual negative input
              onBlur={save}
              onKeyDown={(e) => {
                // prevent arrow down if current value is 0 or less
                const value = Number(e.target.value);
                if (e.key === "ArrowDown" && value <= 0) {
                  e.preventDefault();
                }
              }}
            />
            </Form.Item>
          );
        case "Integer":
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={actualValue}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y" ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <InputNumber controls={false} ref={inputRef} onBlur={save} />
            </Form.Item>
          );
        case "Selector":
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={actualValue}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y" ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <Select
                disabled={colData.isreadonly === "Y" ? true : false}
                style={{ width: "100%", marginBottom: "0px" }}
                placeholder={`Select`}
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onSearch={(value) => {getOptionsMenuData( value)}}
                optionFilterProp="children"
                onFocus={()=>getOptionsMenuData()}
                onSelect={saveOption}
              >
                {optionMenu.map((option, index) => (
                  <Option key={`${option.recordid}-${index}`} value={option.recordid}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          );
        default:
          return (
            <Form.Item
              style={{
                margin: 0,
              }}
              initialValue={actualValue}
              name={dataIndex}
              rules={[
                {
                  required: colData.mandatory === "Y" ? true : false,
                  message: `${title} is required.`,
                },
              ]}
            >
              <Input ref={inputRef} onBlur={save} />
            </Form.Item>
          );
      }
    };

    if (editable) {
      childNode = true ? (
        getField()
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={null}
        >
          {children}
        </div>
      );
    }

    return <td>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
    header: {
      cell: ResizableCell,
    },
  };

  const toggleSelectAllCheckboxes = (columnDataIndex) => {
    const updatedDataSource = [...dataSource];
  
    // Check if all rows in this column are currently selected
    const allSelected = updatedDataSource.every((record) => record[columnDataIndex] === "Y");
  
    // Update each record in the dataSource for the specific column
    updatedDataSource.forEach((record, index) => {
      record[columnDataIndex] = allSelected ? "N" : "Y"; // Toggle selection
    });
  
    // Ensure rows are selected for any column toggle
    const newSelectedRowKeys = [
      ...new Set([
        ...selectedRowKeys,
        ...updatedDataSource.map((_, index) => `${index}`), // Add all rows
      ]),
    ];
  
    // Update checkboxSelections to track column-wise state
    setCheckboxSelections((prevSelections) => ({
      ...prevSelections,
      [columnDataIndex]: updatedDataSource.map((_, index) => index), // Save current column selection
    }));
  
    // Update the selectedRecordsData to reflect the changes
    // setSelectedRecordsData({
    //   ...selectedRecordsData,
    //   [columnDataIndex]: updatedDataSource.map((_, index) => index), // Save updated data for the column
    // });
  
    // Set new row selections even if toggled off
    setSelectedRowKeys(newSelectedRowKeys);
  };

const updatedCols = columns.map((col) => {
  // Check if the column is editable
  if (col.colDataValues.type === "Flag") {
    return {
      ...col,
      width: 120, // Set column width to 120
      onHeaderCell: () => ({
        onClick: () => {
          // Toggle the selection for this column on click
          toggleSelectAllCheckboxes(col.dataIndex);
        },
      }),
    };
  }

  // For non-editable columns, return the column without the onHeaderCell property
  return {
    ...col,
    width: 120, // Set column width to 120
  };
});

  // Function to add a new row
  const handleAddRow = () => {
    const newRowKey = `${dataSource.length}`;
    const tableName = dataSource[0]?.tableName || columns[0]?.colDataValues?.column_name || "";
    const newRow = {
      key: newRowKey,
      tableName,
    };

    columns.forEach((col) => {
      const { dataIndex, colDataValues } = col;
      switch (colDataValues.type) {
        case "Date":
          newRow[dataIndex] = null;
          break;
        case "Flag":
          newRow[dataIndex] = "N";
          break;
        case "Number":
        case "Integer":
          newRow[dataIndex] = 0;
          break;
        case "Selector":
          newRow[dataIndex] = "";
          newRow[`${dataIndex}_iden`] = "";
          break;
        default:
          newRow[dataIndex] = "";
          break;
      }
    });
  //  console.log(newRow,"----->newrow",propTableName)
    handleSave(newRow, propTableName);
    setSelectedRowKeys([...selectedRowKeys, newRowKey]);
  };

  return (
    <>
    {addLineFlag==="Y"?<Button
      onClick={handleAddRow}
      type="primary"
      style={{ marginBottom: 16, fontFamily:"Inter",fontWeight:600,borderRadius:"5px" }}
    >
      Add New Line
    </Button>:null}
    <Table sticky={true} scroll={{ y: "46vh", x: "max-content" }} rowClassName={() => "editable-row"} dataSource={dataSource} columns={updatedCols} components={components} rowSelection={rowSelection} size="small" pagination={false} />
    </>  
  );
};

export default RecordTable;

// import React, { useState, useEffect, useRef } from "react";
// import { Checkbox, Input, Select, InputNumber } from "antd";
// import { DatePicker } from "../../lib/date";
// import { getProcessParamComboFillField } from "../../services/generic";
// import dayjs from "dayjs";
// import { useParams } from "react-router";
// import { Resizable } from "react-resizable";

// const { Option } = Select;

// const RecordTable = (props) => {
//   const { dataSource, columns, selectedRecordsData, setSelectedRecordsData } = props;
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [checkboxSelections, setCheckboxSelections] = useState({});
//   const [optionMenu, setOptionMenu] = useState([]);
//   const { recordId } = useParams();

//   const onSelectRowChange = (selectedRowKeys) => {
//     setSelectedRowKeys([...selectedRowKeys]);
//   };

//   const rowSelection = {
//     selectedRowKeys,
//     onChange: onSelectRowChange,
//   };

//   useEffect(() => {
//     if (dataSource?.length > 0) {
//       const selRecords = { ...selectedRecordsData };
//       selRecords[dataSource[0].tableName] = [...selectedRowKeys];
//       setSelectedRecordsData({ ...selRecords });
//     }
//   }, [selectedRowKeys]);

//   const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, colData, rowIndex }) => {
//     const inputRef = useRef(null);
//     const [value, setValue] = useState(record[dataIndex]);

//     const toggleEdit = () => {
//       setValue(record[dataIndex]);
//     };

//     const save = () => {
//       handleSave({ ...record, [dataIndex]: value });
//       toggleEdit();
//     };

//     const getTimePeriod = () => {
//       const dateValue = record[dataIndex];
//       return dateValue ? dayjs(dateValue) : null;
//     };

//     const getField = () => {
//       switch (colData.type) {
//         case "Date":
//           return (
//             <DatePicker value={getTimePeriod()} onChange={(date) => setValue(date ? date.format("DD-MM-YYYY") : "")} onBlur={save} />
//           );
//         case "Flag":
//           return (
//             <Checkbox
//               checked={value === "Y" || value === "true"}
//               onChange={(e) => setValue(e.target.checked ? "Y" : "N")}
//               onBlur={save}
//             />
//           );
//         case "Number":
//           return (
//             <Input type="number" value={value} onChange={(e) => setValue(e.target.value)} onBlur={save} />
//           );
//         case "Integer":
//           return (
//             <InputNumber value={value} onChange={(value) => setValue(value)} onBlur={save} />
//           );
//         case "Selector":
//           return (
//             <Select
//               value={value}
//               onChange={(value) => setValue(value)}
//               onBlur={save}
//               onSearch={(searchValue) => getOptionsMenuData(searchValue, colData, record)} // Pass colData and record here
//               showSearch
//             >
//               {optionMenu.map((option, index) => (
//                 <Option key={`${option.recordid}-${index}`} value={option.recordid}>
//                   {option.name}
//                 </Option>
//               ))}
//             </Select>
//           );
//         default:
//           return <Input value={value} onChange={(e) => setValue(e.target.value)} onBlur={save} />;
//       }
//     };

//     return editable ? getField() : <div>{children}</div>;
//   };

//   const getOptionsMenuData = (searchValue, colData, record) => {
//     // Ensure that colData and record are available here
//     const stringifiedSession = JSON.stringify(record);
//     const updatedSession = stringifiedSession.replace(/\\"/g, '\\"');
//     const stringRequest = JSON.stringify(updatedSession);
//     getProcessParamComboFillField(colData.nt_process_id, colData.field_id, recordId, stringRequest, searchValue).then((res) => {
//       setOptionMenu(res.data.data.processParamComboFill ? JSON.parse(res.data.data.processParamComboFill) : []);
//     });
//   };

//   const toggleSelectColumnCheckbox = (columnDataIndex) => {
//     console.log(columnDataIndex)
//     const updatedDataSource = [...dataSource];

//     const allSelected = updatedDataSource.every((record) => record[columnDataIndex] === "Y");

//     updatedDataSource.forEach((record, index) => {
//       record[columnDataIndex] = allSelected ? "N" : "Y";
//     });

//     const newSelectedRowKeys = [
//       ...new Set([ ...selectedRowKeys, ...updatedDataSource.map((_, index) => `${index}`) ]),
//     ];

//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const updatedCols = columns.map((col) => {
//     // Check if column has 'type' defined in its colDataValues to handle the checkbox logic
//     if (col.colDataValues.type) {
//       return {
//         ...col,
//         // Ensuring onHeaderCell contains an onClick handler for toggling select all checkboxes
//         onHeaderCell: () => ({
//           onClick: () => {
//             toggleSelectColumnCheckbox(col.dataIndex);
//           },
//         }),
//       };
//     }
  
//     return { ...col };
//   });

//   return (
//     <table>
//       <thead>
//         <tr>
//           {updatedCols.map((col, index) => (
//             <th key={index} style={{ width: 120 }} onClick={col.onHeaderCell ? col.onHeaderCell().onClick : null}>
//               {col.title}
//             </th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>
//         {dataSource.map((record, rowIndex) => (
//           <tr key={rowIndex} className="editable-row">
//             {updatedCols.map((col, colIndex) => (
//               <td key={colIndex}>
//                 <EditableCell
//                   title={col.title}
//                   editable={col.editable}
//                   children={record[col.dataIndex]}
//                   dataIndex={col.dataIndex}
//                   record={record}
//                   handleSave={props.handleSave}
//                   colData={col.colDataValues}
//                   rowIndex={rowIndex}
//                 />
//               </td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

// export default RecordTable;

